<nav class="user-menu" [class.closed]="!isMenuOpen">
  <opac-button (click)="toggleMenu()">
    <opac-icon icon="expand_double_right" slot="only-icon"></opac-icon>
  </opac-button>

  <ul>
    <ng-container *ngFor="let item of userItems">
      <li *ngIf="!item.hide">
        <a
          [attr.aria-label]="item.value"
          [routerLink]="['/user', item.id]"
          routerLinkActive="active"
        >
          <opac-icon
            [badge]="(item.id === 'notifications' && isPendingNotifications) || (item.id === 'events' && userEventsCount > 0)"
            [icon]="item.icon"
          ></opac-icon>

          <span class="link-title">{{ item.value }}</span>

          <opac-tag *ngIf="item.showNewTag">{{ 'general.new' | translate }}</opac-tag>
        </a>
      </li>
    </ng-container>
  </ul>
</nav>
